export default __webpack_public_path__ + "static/soderbergandpartners-7ca87609bb4cc2aa88fcd8446f583a7c.png";